import SlasDemoConfigDialog from './SlasDemoConfigDialog'

export default SlasDemoConfigDialog
